import { Helmet } from "react-helmet";
import SolutionsNtunaCTAWorld from "../components/solutions/SolutionsNtunaCTAWorld";
import WhyBody from "../components/why/WhyBody";
import HowWeWork from "../components/solutions/HowWeWork";
import Authority from "../components/reusables/Authority";
import HomeTestimonials from "../components/home/HomeTestimonials";

export default function Why() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/why-choose-ntuna"
        />
        <meta
          name="description"
          content="Discover why businesses and organizations choose NTUNA.COM for Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        
        <meta
          property="og:description"
          content="Discover why businesses and organizations choose NTUNA.COM for Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Why choose NTUNA.COM for Web and ICT solutions"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Why choose NTUNA.COM for Web and ICT solutions"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Why choose NTUNA.COM for Web and ICT solutions"
        />
        <meta
          name="twitter:description"
          content="Discover why businesses and organizations choose NTUNA.COM for Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>
          NTUNA.COM | Why choose NTUNA.COM for Web and ICT solutions
        </title>
      </Helmet>
      <WhyBody />
      <Authority />
      <HomeTestimonials />
      <HowWeWork />
      <SolutionsNtunaCTAWorld />
    </>
  );
}
